module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Privacy Policy.","mantra":"Privacy |policy."},"ar":{"pageTitle":"سياسة الخصوصية.","mantra":"سياسة |الخصوصية"}}')
  delete Component.options._Ctor
}
